import {Component, ViewChild} from "@angular/core";
import {CourseManagementSearchFormComponent} from "./form/course-management-search-form.component";

@Component({
  selector: "app-course-management",
  templateUrl: "./course-management.component.html",
  styleUrls: ["./course-management.component.scss"],
})
export class CourseManagementComponent {
  mainModel = {};
  showSavedErrorMsg = false;
  showSavedSuccessMsg = false;
  errorsMoreDetails = "";
  formErrors;

  hideCourseManagementSearch = false;
  isLoadingFilters = true;
  results;
  @ViewChild(CourseManagementSearchFormComponent) searchForm;

  constructor() {}

  closeResult = "";

  public closeMessageSuccess(): void {
    this.showSavedSuccessMsg = false;
  }

  public closeMessageError(): void {
    this.showSavedErrorMsg = false;
  }

  public hasSearched(results): void {
    this.results = results;
  }

  public updateSearch(): void {
    this.searchForm.search();
  }
}
